var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressNoteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 3.16675H11.9993C12.353 3.16675 12.6921 3.30722 12.9422 3.55727C13.1922 3.80732 13.3327 4.14646 13.3327 4.50008V13.8334C13.3327 14.187 13.1922 14.5262 12.9422 14.7762C12.6921 15.0263 12.353 15.1667 11.9993 15.1667H3.99935C3.64573 15.1667 3.30659 15.0263 3.05654 14.7762C2.80649 14.5262 2.66602 14.187 2.66602 13.8334V4.50008C2.66602 4.14646 2.80649 3.80732 3.05654 3.55727C3.30659 3.30722 3.64573 3.16675 3.99935 3.16675H5.33268",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 1.83325H6.00065C5.63246 1.83325 5.33398 2.13173 5.33398 2.49992V3.83325C5.33398 4.20144 5.63246 4.49992 6.00065 4.49992H10.0007C10.3688 4.49992 10.6673 4.20144 10.6673 3.83325V2.49992C10.6673 2.13173 10.3688 1.83325 10.0007 1.83325Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressNoteIcon);
export default __webpack_public_path__ + "static/media/ProgressNoteIcon.362af6ce3c62301c0e894a60dae626d0.svg";
export { ForwardRef as ReactComponent };